/**
 * @module Theme
 */

import { Component, Input, OnInit } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-datalabels-border-color',
  templateUrl: './theme-option-datalabels-border-color.component.html',
  styleUrls: ['./theme-option-datalabels-border-color.component.css']
})
export class ThemeOptionDatalabelsBorderColorComponent implements OnInit {

  @Input() themeOptions: ThemeOptionsClass;
  @Input() datalabelsIndex: number;

  showDetails: boolean;
  color = ItemColor('themes');
  opacity: number;
  borderColor: string;
  optionType: ThemeOptionType = 'datalabels_borderColor';

  constructor() {
    this.showDetails = false;
  }

  receiveShowDetails(showDetails: boolean) {
    this.showDetails = showDetails;
  }

  ngOnInit() {
    this.borderColor = this.themeOptions.datalabels(this.datalabelsIndex).borderColor.toString().slice(0, 7);
    this.opacity = Math.round(parseInt(this.themeOptions.datalabels(this.datalabelsIndex).borderColor.toString().slice(7, 9), 16) * 100 / 255);
  }
  
  receiveValue(value: string) {
    this.borderColor = value;
    this.themeOptions.setDatalabels(this.optionType, value + Math.round(this.opacity * 255 / 100).toString(16), this.datalabelsIndex);
  }

  receiveOpacity(value: number) {
    this.opacity = value;
    if(this.opacity > 0) {
      this.themeOptions.setDatalabels(this.optionType, this.borderColor + Math.round(value * 255 / 100).toString(16), this.datalabelsIndex);
    }
    else {
      this.themeOptions.setDatalabels(this.optionType, this.borderColor + '00', this.datalabelsIndex);
    }
  }

}
